import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-black text-white">
            <div className="max-w-4xl mx-auto px-6 py-12">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 text-gray-400 hover:text-purple-400 transition-colors mb-8"
                >
                    <ArrowLeft size={20} />
                    Back
                </button>

                <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>

                <div className="space-y-8 text-gray-300">
                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
                        <p>
                            By accessing and using Papers with Graph, you agree to be bound by these Terms of Service.
                            If you disagree with any part of these terms, you may not access our service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">2. Subscription and Payments</h2>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Subscription fees are billed in advance on a monthly basis</li>
                            <li>You can cancel your subscription at any time</li>
                            <li>Refunds are handled according to our Refund Policy</li>
                            <li>We use Paddle as our payment processor</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">3. User Responsibilities</h2>
                        <p className="mb-4">You agree to:</p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Provide accurate account information</li>
                            <li>Maintain the security of your account</li>
                            <li>Use the service in compliance with applicable laws</li>
                            <li>Not misuse or abuse the service</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">4. Intellectual Property</h2>
                        <p>
                            Papers with Graph and its original content, features, and functionality are owned by
                            Papers with Graph and are protected by international copyright, trademark, patent,
                            trade secret, and other intellectual property laws.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">5. Limitation of Liability</h2>
                        <p>
                            Papers with Graph shall not be liable for any indirect, incidental, special,
                            consequential, or punitive damages resulting from your use of or inability to use
                            the service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">6. Changes to Terms</h2>
                        <p>
                            We reserve the right to modify these terms at any time. We will notify users of any
                            material changes via email or through the service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-white mb-4">7. Contact</h2>
                        <p>
                            For any questions about these Terms, please contact us at{' '}
                            <a href="mailto:legal@paperswithgraph.com" className="text-purple-400 hover:text-purple-300">
                                legal@paperswithgraph.com
                            </a>
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService; 